import { render } from "./RemainingDays.vue?vue&type=template&id=459a1be2&scoped=true"
import script from "./RemainingDays.vue?vue&type=script&lang=js"
export * from "./RemainingDays.vue?vue&type=script&lang=js"

import "./remain-days.scss?vue&type=style&index=0&id=459a1be2&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459a1be2"]])

export default __exports__